function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable max-lines */
/* eslint-disable import/exports-last */
import React from 'react';
import PropTypes from 'prop-types';
import { flattenDeep } from 'lodash';
import { t } from "../../I18N";
import { Icon } from "../../UI";
import MarkdownViewer from "../../Markdown";
import { GroupedGeolocationViewer } from "./GroupedGeolocationViewer";
import { MediaPlayer } from "../../V2/Components/UI";
import GeolocationViewer from "./GeolocationViewer";
import { RelationshipLink } from "./RelationshipLink";
import ValueList from "./ValueList";
import { ImageViewer } from "./ImageViewer";

const getMediaUrlAndName = (fileUrl) => {
  let url = fileUrl;
  let filename = url.split('/').pop();

  if (fileUrl.includes('timelinks')) {
    url = fileUrl.substring(1, fileUrl.indexOf(','));
    filename = filename.substring(0, filename.indexOf(','));
  }

  return { url, filename };
};

const renderRelationshipLinks = (linksProp, compact) => {
  if (linksProp.type === 'newRelationship' && !linksProp.value) {
    return [];
  }
  const formattedLinkValues = Array.isArray(linksProp.value) ? linksProp.value : [linksProp.value];
  const hydratedValues = formattedLinkValues.map((linkValue) => ({
    value: /*#__PURE__*/_jsx(RelationshipLink, { propValue: linkValue })
  }));
  const hydratedProp = _objectSpread(_objectSpread({}, linksProp), {}, { value: hydratedValues });
  return /*#__PURE__*/_jsx(ValueList, { compact: compact, property: hydratedProp });
};

const renderLink = (prop, compact) => {
  const { url, label } = prop.value;
  const renderLabel = label || url;
  if (!renderLabel) {
    return null;
  }

  return (/*#__PURE__*/
    _jsx("a", { href: url, target: "_blank", rel: "noopener noreferrer" }, void 0,
    renderLabel.length > 40 && compact ? `${renderLabel.substring(0, 40)}...` : renderLabel
    ));

};

export const showByType = ({ prop, templateId = '', useV2Player = false, compact = false }) => {
  let result = prop.value;

  switch (prop.type) {
    case null:
      result = t('System', 'No property');
      break;
    case 'markdown':
      result = /*#__PURE__*/_jsx(MarkdownViewer, { html: true, markdown: prop.value });
      break;
    case 'link':
      result = renderLink(prop, compact);
      break;
    case 'image':
      result = prop.value && /*#__PURE__*/
      _jsx(ImageViewer, {

        className: `multimedia-img ${prop.style}`,
        src: prop.value,
        alt: prop.label }, prop.value
      );

      break;
    case 'media':{
        if (useV2Player && prop.value) {
          result = /*#__PURE__*/
          _jsx("div", {
            className: "tw-content video-container compact",
            onClick: (e) => {
              e.stopPropagation();
            } }, void 0, /*#__PURE__*/

          _jsx(MediaPlayer, {
            url: prop.value,
            thumbnail: {
              fileName: prop.fileName || ''
            } }
          )
          );

        } else {
          result = prop.value && /*#__PURE__*/_jsx(MarkdownViewer, { markdown: `{media}(${prop.value})`, compact: true });
        }
        break;
      }
    case 'geolocation':
      result = /*#__PURE__*/
      _jsx(GeolocationViewer, {
        points: prop.value,
        onlyForCards: Boolean(prop.onlyForCards || compact) }
      );

      break;
    case 'select':
      result = prop.parent ? `${prop.parent}: ${prop.value}` : result;
      break;
    case 'geolocation_group':
      result = /*#__PURE__*/_jsx(GroupedGeolocationViewer, { members: prop.members, templateId: templateId });
      break;
    case 'relationship':
    case 'newRelationship':
      result = renderRelationshipLinks(prop, compact);
      break;
    default:
      if (prop.value && prop.value.map) {
        const propValue = flattenDeep(
          prop.value.map((_value) =>
          _value.parent && Array.isArray(_value.value) ?
          flattenDeep(
            _value.value.map((v) => _objectSpread(_objectSpread({}, v), {}, { value: `${_value.parent}: ${v.value}` }))
          ) : _objectSpread(_objectSpread({},
          _value), _value.parent && { value: `${_value.parent}: ${_value.value}` })
          )
        );

        // eslint-disable-next-line no-param-reassign
        prop.value = propValue.map((_value) => {
          const value = showByType({ prop: _value, templateId, compact });
          return value && value.value ?
          value : _objectSpread({
            value }, _value.icon !== undefined ? { icon: _value.icon } : {});
        });
        result = /*#__PURE__*/_jsx(ValueList, { compact: compact, property: prop });
      }
      break;
  }

  return result;
};

const computeGroup = (metadata, startIndex) => {
  const members = [];
  let index = startIndex;
  let lastIndexInTemplate = metadata[index].indexInTemplate - 1;

  while (
  index < metadata.length &&
  metadata[index].type === 'geolocation' &&
  metadata[index].indexInTemplate === lastIndexInTemplate + 1)
  {
    members.push(metadata[index]);
    lastIndexInTemplate = metadata[index].indexInTemplate;
    index += 1;
  }

  return [members, index];
};

const getNewGroupedGeolocationField = (members) => {
  if (members.length === 1) {
    return {
      type: 'geolocation_group',
      name: 'geolocation_group',
      label: members[0].label,
      translateContext: members[0].translateContext,
      members
    };
  }

  return {
    type: 'geolocation_group',
    label: 'Combined geolocations',
    members
  };
};

const groupAdjacentGeolocations = (metadata) => {
  const groupedMetadata = [];
  let index = 0;

  while (index < metadata.length) {
    if (metadata[index].type !== 'geolocation') {
      groupedMetadata.push(metadata[index]);
      index += 1;
    } else {
      const [members, i] = computeGroup(metadata, index);

      index = i;
      groupedMetadata.push(getNewGroupedGeolocationField(members));
    }
  }

  return groupedMetadata;
};

function filterProps(showSubset) {
  return (p) => {
    if (showSubset && !showSubset.includes(p.name)) {
      return false;
    }
    if (p.obsolete) {
      return true;
    }
    if (Array.isArray(p.value)) {
      return p.value.length;
    }
    return p.value || p.type === null || p.type === 'numeric' && p.value === 0;
  };
}

const flattenInherittedRelationships = (metadata) =>
metadata.map((property) => {
  if (property.type === 'inherit' && property.inheritedType === 'relationship') {
    // eslint-disable-next-line no-param-reassign
    property.value = property.value.reduce(
      (flattenedValues, v) => flattenedValues.concat(v.value || []),
      []
    );
  }
  return property;
});

const Metadata = ({
  metadata,
  compact = false,
  showSubset = undefined,
  highlight = [],
  groupGeolocations = false,
  templateId,
  useV2Player = false,
  attachments
}) => {
  const filteredMetadata = metadata.filter(filterProps(showSubset));
  const flattenedMetadata = flattenInherittedRelationships(filteredMetadata);
  const groupedMetadata = groupGeolocations ?
  groupAdjacentGeolocations(flattenedMetadata) :
  flattenedMetadata;

  return groupedMetadata.map((prop, index) => {
    let type = prop.type ? prop.type : 'default';
    type = type === 'image' || type === 'media' ? 'multimedia' : type;
    const highlightClass = highlight.includes(prop.name) ? 'highlight' : '';
    const fullWidthClass = prop.fullWidth ? 'full-width' : '';

    if (prop.type === 'media' && useV2Player && attachments) {
      const { filename, url } = getMediaUrlAndName(prop.value);

      if (url.startsWith('/api/files')) {var _attachments$find;
        prop.fileName =
        ((_attachments$find = attachments.find((attachment) => attachment.filename === filename)) === null || _attachments$find === void 0 ? void 0 : _attachments$find.originalname) || '';
      }

      prop.value = url;
    }

    return (/*#__PURE__*/
      _jsx("dl", {
        className: `metadata-type-${type} metadata-name-${prop.name} ${fullWidthClass} ${highlightClass}` },
      `${prop.name}_${index}`, /*#__PURE__*/

      _jsx("dt", { className: prop.noLabel ? 'hidden' : '' }, void 0,
      t(prop.translateContext || 'System', prop.label),
      prop.obsolete ? [' ', /*#__PURE__*/_jsx(Icon, { icon: "spinner", spin: true })] : null
      ), /*#__PURE__*/
      _jsx("dd", { className: prop.sortedBy ? 'item-current-sort' : '' }, void 0,
      showByType({ prop, templateId, compact, useV2Player })
      )
      ));

  });
};




























export default Metadata;